export default function CardsWithCenterImage({ statsData }) {
  return (
    <>
      <div className=" bg-white p-8 w-full">
        <div className="mx-auto text-center mb-10">
          <h2 className="text-2xl md:text-4xl font-bold text-custom-pink">
            AI Impact On Jobs By Numbers
          </h2>
        </div>

        <div className="mx-auto grid grid-cols-1 md:grid-cols-4 gap-6">
          {/* Statistics Cards - Top Row */}
          {statsData.slice(0, 1).map((stat, index) => (
            <div
              key={index}
              className="bg-petal-pink rounded-3xl p-6 shadow-lg text-left"
            >
              <p className="bg-custom-gradient bg-clip-text text-transparent text-4xl font-bold min-w-[100px] w-fit">
                {stat.percentage}
              </p>
              <h3 className="text-lg font-semibold mt-2 text-custom-pink">
                {stat.title}
              </h3>
              <p className="text-gray-600 text-sm mt-2">{stat.description}</p>
              <a
                href={stat.link}
                target="_blank"
                rel="noopener noreferrer"
                className="text-custom-blue text-sm mt-3 inline-block underline"
              >
                Learn More →
              </a>
            </div>
          ))}

          {/* Central Image */}
          <div className="md:col-span-2 md:flex md:items-center md:justify-center hidden">
            <img
              src="/centeralImage.png"
              alt="AI Impact Central"
              className="rounded-3xl object-cover w-full h-full"
            />
          </div>

          {/* Statistics Cards - Top Row Continued */}
          {statsData.slice(1, 4).map((stat, index) => (
            <div
              key={index}
              className="bg-petal-pink rounded-3xl p-6 shadow-lg text-left"
            >
              <p className="bg-custom-gradient bg-clip-text text-transparent text-4xl font-bold min-w-[100px] w-fit">
                {stat.percentage}
              </p>

              <h3 className="text-lg font-semibold mt-2 text-custom-pink">
                {stat.title}
              </h3>
              <p className="text-gray-600 text-sm mt-2">{stat.description}</p>
              <a
                href={stat.link}
                target="_blank"
                rel="noopener noreferrer"
                className="text-custom-blue text-sm mt-3 inline-block underline"
              >
                Learn More →
              </a>
            </div>
          ))}

          {/* Statistics Cards - Bottom Row */}
          {statsData.slice(4).map((stat, index) => (
            <div
              key={index}
              className="bg-petal-pink rounded-3xl p-6 shadow-lg text-left"
            >
              <p className="bg-custom-gradient bg-clip-text text-transparent text-4xl font-bold min-w-[100px] w-fit">
                {stat.percentage}
              </p>

              <h3 className="text-lg font-semibold mt-2 text-custom-pink">
                {stat.title}
              </h3>
              <p className="text-gray-600 text-sm mt-2">{stat.description}</p>
              <a
                href={stat.link}
                target="_blank"
                rel="noopener noreferrer"
                className="text-custom-blue text-sm mt-3 inline-block underline"
              >
                Learn More →
              </a>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
